export const PRODUCT_STATUS_DRAFT = "DRAFT";
export const PRODUCT_STATUS_ACTIVE = "ACTIVE";
export const PRODUCT_STATUS_ARCHIVED = "ARCHIVED";
